import React from 'react';

/**
 * Renders a technical spec table. Rows can have Parameter/Value or Parameter/value (lowercase).
 */
export default function TechnicalDataTable({ data, headers = ['Parameter', 'Value'], title, className = '' }) {
  if (!data || !Array.isArray(data)) return null;

  const normalizeLabel = (param) => {
    if (!param) return '';
    // If it's already human readable (contains a space), keep as is
    if (param.includes(' ')) return param;

    let raw = param;
    let unitLabel = '';

    // Extract common units encoded in the key suffix
    const unitMatch = raw.match(/_(mm|cm|m|kg|kva|deg_c)$/i);
    if (unitMatch) {
      const full = unitMatch[0];
      const unit = unitMatch[1].toLowerCase();
      raw = raw.slice(0, -full.length);
      if (unit === 'deg_c') unitLabel = '°C';
      else unitLabel = unit.toUpperCase();
    }

    // Replace underscores with spaces and title-case
    const words = raw.split('_').filter(Boolean);
    const labelText = words
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');

    return unitLabel ? `${labelText} (${unitLabel})` : labelText;
  };

  const rows = data.map((row) => {
    const rawParam = row.Parameter || row.parameter;
    const param = normalizeLabel(rawParam);
    const val = row.Value !== undefined ? row.Value : (row.value !== undefined ? row.value : '');
    return { param, val };
  });

  return (
    <div className={`quotation-section quotation-no-break ${className}`} style={{ marginBottom: 20 }}>
      {title && (
        <p
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 600,
            fontSize: 13,
            color: '#000814',
            margin: '0 0 10px 0',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </p>
      )}
      <table className="quotation-table" style={{ fontSize: 13 }}>
        <thead>
          <tr>
            {(headers || ['Parameter', 'Value']).map((h, i) => (
              <th key={i} style={{ width: i === 0 ? '40%' : '60%' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              <td><strong>{r.param}</strong></td>
              <td>{r.val}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
